import {Tag} from "../model/Tag";
import {RtrTagHandler} from "./RtrTagHandler";

export const inferTag = async (params): Promise<Tag> => {
    const rtrTagHandler = new RtrTagHandler()
    const { type, tagId } = params;
    if (type === "placement-tag") {
        const rtrTagXml = await rtrTagHandler.fetchRtrTagXml(tagId)
        if (rtrTagXml) {
            const placementTagInfo = rtrTagHandler.extractPlacementInfoFromRtrXml(rtrTagXml)
            if (placementTagInfo.hash) {
                const inferredType = "placement"
                const inferredTagId = placementTagInfo.hash
                const ivcParams = placementTagInfo.ivcQueryParams ? placementTagInfo.ivcQueryParams : ""
                return {type: inferredType, tagId: inferredTagId, ivcQueryParams: ivcParams}
            } else {
                return {type, tagId}
            }
        } else {
            return {type, tagId}
        }
    } else {
        return {type, tagId}
    }
}